// @format

export function initTimeZone(): void {
  var offset = -new Date().getTimezoneOffset() / 60;
  document.cookie =
    'browser.tzoffset=' +
    offset +
    '; expires=Fri, 3 Aug 2031 20:47:11 UTC; path=/';
}
